var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActivePane(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "airplanemode_active"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3937_71638",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3937_71638)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "airplanemode_active_2",
    d: "M7.34772 17.9174V16.9399L8.96647 15.7378V11.0024L2.08334 13.0376V11.7555L8.96647 7.68513V3.10971C8.96647 2.82124 9.06661 2.57687 9.26688 2.37659C9.46716 2.17631 9.71154 2.07617 10 2.07617C10.2885 2.07617 10.5329 2.17631 10.7331 2.37659C10.9334 2.57687 11.0336 2.82124 11.0336 3.10971V7.68513L17.9167 11.7555V13.0376L11.0336 11.0024V15.7218L12.6523 16.9399V17.9174L10 17.1483L7.34772 17.9174Z",
    fill: "#357EFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivePane);
export default __webpack_public_path__ + "static/media/ActivePane.bd7a04cf45b01d1a60cd1098f7720dec.svg";
export { ForwardRef as ReactComponent };